

import { abonosApi } from "../../apis";
import Swal from "sweetalert2";





export const abonosXOp = async(id) => {
    try {
        const { data } = await abonosApi.get(`/abonosxop/${id}`);
        return data.data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}



export const crearAbonoOps = async(datos) => {
    try {
        const formData = new FormData();
        if(datos?.img && typeof datos?.img !== 'string') { formData.append('images', datos.img); }
        Object.entries(datos).forEach(([key, value]) => {
            formData.append(key, value?.toString());
        });
        
        await abonosApi.post(`/new`, formData);
        Swal.fire('Exitoso', 'Abono Creado', 'success');
        return true;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}




export const eliminarAbonoOp = async(id) => {
    try {
        await abonosApi.delete(`/${id}`);
        Swal.fire('Exitoso', 'Abono e imagen eliminados', 'success');
        return true;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}